<template>
    <div class="animated fadeIn">
        <form @submit="ValidarForm">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <header class="card-header">
                            <div :class="classHeader">
                                <div>
                                    <img :src="pesquisa.imageId ? $store.getters.baseURL + 'arquivo/obter/' + pesquisa.imageId : 'img/avatar.svg'"
                                        height="60" alt="PrismaSync Logo" />

                                </div>
                                <div class="ml-auto">
                                    <div>
                                        <strong> {{ $t("sectionPesquisaSatisfacao.atendimento") }} {{
                                            pesquisa.atendimento.telefone }}</strong>
                                    </div>
                                    <strong>
                                        {{ $t("sectionPesquisaSatisfacao.responsavel") }} {{
                                            pesquisa.atendimento.usuarioNome }}
                                    </strong>
                                </div>
                                <div class="ml-auto">
                                    <strong>
                                        {{ $t("sectionPesquisaSatisfacao.dataAbertura") }} <label for>{{
                                            new Date(pesquisa.atendimento.dataAbertura).toLocaleString()
                                        }}</label>
                                        <div >
                                            {{ $t("sectionPesquisaSatisfacao.dataFechamento") }} <label for>{{
                                                new Date(pesquisa.atendimento.dataFechamento).toLocaleString()
                                            }}</label>
                                        </div>
                                    </strong>
                                </div>
                            </div>
                        </header>
                        <div v-if="loading" class="loading-container">
                            <RotateSquare class="loading-position animated fadeIn" size="60px"></RotateSquare>
                        </div>
                        <div v-if="pesquisaRespondida" class="card-body text-center">
                            <div>
                                <img src="img/avaliacao.svg" :height="tamanhoImgAvalidao" alt="PrismaSync Logo" />
                            </div>
                            <div>
                                <label>
                                    <h2>{{ $t("sectionPesquisaSatisfacao.avaliacaoRegistrada") }}</h2>
                                </label>
                            </div>
                            <label>
                                <h2>{{ $t("sectionPesquisaSatisfacao.dataAvaliacao") }} {{
                                    new Date(dataAvaliacao).toLocaleString()
                                }}</h2>
                            </label>
                        </div>
                        <div v-if="!loading && !pesquisaRespondida" class="card-body">
                            <div v-for="pergunta in pesquisa.perguntas" :key="pergunta.id" class="text-center card ">
                                <strong class="mb-2">{{ pergunta.index }} - {{ pergunta.descricaoPergunta }}
                                    <span v-if="pergunta.obrigatorio" class="badge badge-warning">
                                        {{ $t("sectionPesquisaSatisfacao.obrigatorio") }}
                                    </span>
                                    <span v-if="!pergunta.obrigatorio" class="badge badge-secondary">
                                        {{ $t("sectionPesquisaSatisfacao.opcional") }}
                                    </span>
                                </strong>

                                <div v-if="pergunta.tipoResposta === 1" class="mb-2">
                                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-6 center">
                                        <textarea v-model="pergunta.resposta" class="form-control" type="text"
                                            maxlength="1024" :required="pergunta.obrigatorio" />
                                    </div>
                                </div>
                                <div v-if="pergunta.tipoResposta === 2" class="mb-2">
                                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-2 center" style="position: relative;">
                                        <b-form-rating v-model="pergunta.resposta" variant="warning"
                                            size="lg"></b-form-rating>
                                        <input type="number" :required="pergunta.obrigatorio" v-model="pergunta.resposta"
                                            style="width: 100%; height:0%; opacity: 0; position: absolute; top: 100%; left: 0;">
                                    </div>

                                </div>
                                <div v-if="pergunta.tipoResposta === 3" class="mb-4">
                                    <b-form-radio-group :required="pergunta.obrigatorio" v-model="pergunta.resposta" buttons
                                        button-variant="warning" :size="isSmallScreen" >
                                        <b-form-radio :value="1" class="gradient-button" :class="pergunta.resposta === 1 ? 'opcao-selecionada':''"
                                        :style="{ backgroundColor: getButtonColor(1)}">1</b-form-radio>
                                        <b-form-radio :value="2" class="gradient-button" :class="pergunta.resposta === 2? 'opcao-selecionada':''"
                                            :style="{ backgroundColor: getButtonColor(2) }">2</b-form-radio>
                                        <b-form-radio :value="3" class="gradient-button" :class="pergunta.resposta === 3 ? 'opcao-selecionada':''"
                                            :style="{ backgroundColor: getButtonColor(3) }">3</b-form-radio>
                                        <b-form-radio :value="4" class="gradient-button" :class="pergunta.resposta === 4 ? 'opcao-selecionada':''"
                                            :style="{ backgroundColor: getButtonColor(4) }">4</b-form-radio>
                                        <b-form-radio :value="5" class="gradient-button" :class="pergunta.resposta === 5 ? 'opcao-selecionada':''"
                                            :style="{ backgroundColor: getButtonColor(5) }">5</b-form-radio>
                                        <b-form-radio :value="6" class="gradient-button" :class="pergunta.resposta === 6 ? 'opcao-selecionada':''"
                                            :style="{ backgroundColor: getButtonColor(6) }">6</b-form-radio>
                                        <b-form-radio :value="7" class="gradient-button" :class="pergunta.resposta === 7 ? 'opcao-selecionada':''"
                                            :style="{ backgroundColor: getButtonColor(7) }">7</b-form-radio>
                                        <b-form-radio :value="8" class="gradient-button" :class="pergunta.resposta === 8 ? 'opcao-selecionada':''"
                                            :style="{ backgroundColor: getButtonColor(8) }">8</b-form-radio>
                                        <b-form-radio :value="9" class="gradient-button" :class="pergunta.resposta === 9 ? 'opcao-selecionada':''"
                                            :style="{ backgroundColor: getButtonColor(9) }">9</b-form-radio>
                                        <b-form-radio :value="10" class="gradient-button" :class="pergunta.resposta === 10 ? 'opcao-selecionada':''"
                                            :style="{ backgroundColor: getButtonColor(10) }">10</b-form-radio>
                                    </b-form-radio-group>
                                </div>
                                <div v-if="pergunta.tipoResposta === 4" class="mb-3">
                                    <b-form-radio-group :required="pergunta.obrigatorio" v-model="pergunta.resposta" buttons
                                        button-variant="outline-primary" :size="isSmallScreen">
                                        <b-form-radio :value="true">{{ $t("textYes") }}</b-form-radio>
                                        <b-form-radio :value="false">{{ $t("textNo") }}</b-form-radio>

                                    </b-form-radio-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button v-if="!pesquisaRespondida" class="btn btn-success" type="submit">
                        {{ $t("btSalvar") }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
  
<script>
import RotateSquare from "../../components/RotateSquare";

export default {
    name: "PesquisaSatisfacaoCliente",
    components: {
        RotateSquare
    },
    data() {
        return {
            locale: this.$i18n.locale,
            pesquisa: null,
            loading: false,
            pesquisaRespondida: false,
            dataAvaliacao: null,
            isSmallScreen: "lg",
            classHeader:"d-flex",
            tamanhoImgAvalidao:"300",
            viewModel: {
                contaId: null,
                atendimentoId: null,
                perguntas: []
            },
        };
    },
    computed: {
    },

    mounted() {
        let atendimentoId = this.$route.params.atendimentoId;
        let contaId = this.$route.params.contaId;


        if (atendimentoId && contaId)
            this.Obter(atendimentoId, contaId);

        window.addEventListener('resize', this.handleResize);
        
        if(window.innerWidth >= 510){
                this.isSmallScreen = "lg";
                this.classHeader = "d-flex";
                this.tamanhoImgAvalidao = "300"
            }
            else{
                this.isSmallScreen = "sm";
                this.classHeader = "";
                this.tamanhoImgAvalidao = "200"
            }
    },
    destroyed() {
        // Remove o ouvinte de evento quando o componente for destruído
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            if(window.innerWidth >= 510){
                this.isSmallScreen = "lg";
                this.classHeader = "d-flex";
                this.tamanhoImgAvalidao = "300"
            }
            else{
                this.isSmallScreen = "sm";
                this.classHeader = "";
                this.tamanhoImgAvalidao = "200"
            }
        },
        getButtonColor(value) {
            // Calcular uma transição suave entre vermelho, laranja e verde com base no valor
            const red = Math.floor(Math.max(255 - Math.abs(value - 5) * 25.5, 0));
            const green = Math.floor(Math.min((value - 1) * 25.5, 255));
            const blue = 0;

            return `rgb(${red}, ${green}, ${blue})`;
        },
        ValidarForm(evt) {
            evt.preventDefault();
            console.log("respostas", this.pesquisa.perguntas)

            this.RegistrarPesquisa();
        },
        RegistrarPesquisa() {
            this.loading = true;
            this.viewModel.perguntas = this.pesquisa.perguntas;
            const novaData = new Date();
            this.$http({
                url: "pesquisa-satisfacao/registrar-pesquisa",
                data: this.viewModel,
                method: "POST"
            })
                .then(() => {
                    this.loading = false;
                    this.pesquisaRespondida = true;
                    this.dataAvaliacao = novaData;
                })
                .catch((erro) => {
                    this.loading = false;
                    this.$notify({
                        data: [erro.response.data],
                        type: "warn",
                        duration: 10000
                    });
                });
        },
        Obter(atendimentoId, contaId) {
            this.loading = true;
            this.$http({
                url: "pesquisa-satisfacao/obter-cliente/" + atendimentoId + "/" + contaId,
                method: "GET"
            })
                .then((resposta) => {
                    this.loading = false;
                    //console.log(resposta.data)
                    this.pesquisa = resposta.data
                    this.viewModel.atendimentoId = atendimentoId;
                    this.viewModel.contaId = contaId;
                    this.pesquisaRespondida = resposta.data.atendimento.avaliado;
                    this.dataAvaliacao = resposta.data.atendimento.dataAvaliacao;
                })
                .catch((erro) => {
                    this.loading = false;
                    this.$notify({
                        data: erro.response.data.erros,
                        type: "warn",
                        duration: 10000
                    });
                });
        }
    }
};
</script>
  
<style>
.opcao-selecionada {
    border: 2px solid rgb(50, 143, 248);
}
.center {
    display: inline-block !important;
}

.gradient-button {
    color: white;
}
</style>
  